(function () {
  "use strict";

  function PosPaymentController(
    $mdDialog,
    $mdToast,
    PosPaymentService,
    AlertToastService
  ) {
    var $ctrl = this;

    // INPUT | PENDING | SUCCESS | FAILED | TIMEOUT
    $ctrl.step = "INPUT";
    $ctrl.payableAmount = 0;
    $ctrl.errorMessage = "";
    $ctrl.receiptData = null;
    $ctrl.isEditing = false;

    $ctrl.$onInit = function () {
      $ctrl.payableAmount = $ctrl.totalAmount || 0;
      $ctrl.paymentUnit = $ctrl.paymentUnit || "TOMAN";
    };

    $ctrl.cancel = function () {
      $mdDialog.cancel();
    };

    $ctrl.toggleEdit = function () {
      $ctrl.isEditing = !$ctrl.isEditing;
    };

    $ctrl.sendToPos = function () {
      var payload;

      if (!$ctrl.payableAmount || $ctrl.payableAmount <= 0) {
        handleError("مبلغ پرداخت باید بیشتر از صفر باشد.");
        return;
      }

      if (!$ctrl.invoiceInfoId) {
        handleError("شناسه اطلاعات فاکتور ارسال نشده است.");
        return;
      }

      if (!$ctrl.terminalId) {
        handleError("شناسه ترمینال کارتخوان ارسال نشده است.");
        return;
      }

      $ctrl.step = "PENDING";
      $ctrl.errorMessage = "";
      $ctrl.receiptData = null;

      payload = {
        amount: Number($ctrl.payableAmount),
        invoiceInfoId: $ctrl.invoiceInfoId,
        terminalId: $ctrl.terminalId
      };

      if ($ctrl.paymentUnit) {
        payload.unit = $ctrl.paymentUnit;
      }

      PosPaymentService.sendToPos().save(
        payload,
        function (res) {
          var authorityToken = getAuthorityToken(res);

          if (!authorityToken) {
            handleError(
              (res && res.message) ||
                "توکن استعلام تراکنش (authorityToken) از سرویس دریافت نشد."
            );
            return;
          }
          checkStatusOnce(authorityToken);
        },
        function (err) {
          if (err && err.status === 408) {
            $ctrl.step = "TIMEOUT";
            return;
          }

          handleError(getErrorMessage(err));
        }
      );
    };

    function checkStatusOnce(authorityToken) {
      PosPaymentService.checkStatus().get(
        {
          authorityToken: authorityToken
        },
        function (paymentLogs) {
          var paymentLog;
          var status;

          paymentLog = getLatestPaymentLog(paymentLogs);

          if (!paymentLog) {
            handleError("پاسخی برای وضعیت تراکنش دریافت نشد.");
            return;
          }

          status = getPaymentStatus(paymentLog);

          if (isSuccessfulStatus(status)) {
            handleSuccess(paymentLog);
            return;
          }

          if (isFailedStatus(status)) {
            handleError(
              paymentLog.message ||
                paymentLog.description ||
                "تراکنش توسط مشتری لغو شد یا ناموفق بود."
            );
            return;
          }

          /*
           * در حالت جدید، سرویس باید نتیجه نهایی را برگرداند.
           * بنابراین ACTIVE / PENDING نباید به کلاینت بازگردد.
           */
          handleError(
            paymentLog.message ||
              paymentLog.description ||
              "وضعیت نهایی تراکنش از سرویس دریافت نشد."
          );
        },
        function (err) {
          if (err && err.status === 408) {
            $ctrl.step = "TIMEOUT";
            return;
          }

          handleError(
            getErrorMessage(err) ||
              "استعلام وضعیت تراکنش با خطا مواجه شد."
          );
        }
      );
    }

    function getAuthorityToken(response) {
      if (!response) {
        return null;
      }

      if (response.authorityToken) {
        return response.authorityToken;
      }

      if (response.authority) {
        return response.authority;
      }

      if (response.token) {
        return response.token;
      }

      if (response.data && response.data.authorityToken) {
        return response.data.authorityToken;
      }

      if (response.result && response.result.authorityToken) {
        return response.result.authorityToken;
      }

      return null;
    }

    function getLatestPaymentLog(paymentLogs) {
      if (!paymentLogs) {
        return null;
      }

      if (angular.isArray(paymentLogs)) {
        if (paymentLogs.length === 0) {
          return null;
        }

        return paymentLogs[paymentLogs.length - 1];
      }

      return paymentLogs;
    }

    function getPaymentStatus(paymentLog) {
      var status;

      if (!paymentLog) {
        return "";
      }

      status =
        paymentLog.status ||
        paymentLog.paymentStatus ||
        paymentLog.transactionStatus ||
        paymentLog.state ||
        "";

      return String(status).toUpperCase();
    }

    function isSuccessfulStatus(status) {
      return (
        status === "OK" ||
        status === "SUCCESS" ||
        status === "SUCCEEDED" ||
        status === "PAID" ||
        status === "COMPLETED" ||
        status === "SUCCESSFUL"
      );
    }

    function isFailedStatus(status) {
      return (
        status === "NOK" ||
        status === "FAILED" ||
        status === "FAIL" ||
        status === "CANCELED" ||
        status === "CANCELLED" ||
        status === "REJECTED" ||
        status === "ERROR"
      );
    }

    function getErrorMessage(err) {
      if (err && err.data && err.data.message) {
        return err.data.message;
      }

      if (err && err.data && err.data.error) {
        return err.data.error;
      }

      if (err && err.statusText) {
        return err.statusText;
      }

      return "ارسال تراکنش به دستگاه کارتخوان با خطا مواجه شد.";
    }

    function handleSuccess(data) {
      $ctrl.receiptData = data || {};
      $ctrl.step = "SUCCESS";

      $mdToast.show(
        $mdToast
          .simple()
          .textContent("پرداخت با موفقیت انجام شد")
          .position("top left")
      );
    }

    function handleError(message) {
      $ctrl.errorMessage = message || "تراکنش ناموفق بود.";
      $ctrl.step = "FAILED";
    }

    $ctrl.retry = function () {
      $ctrl.sendToPos();
    };

    $ctrl.closeSuccess = function () {
      $mdDialog.hide($ctrl.receiptData);
    };
  }

  PosPaymentController.$inject = [
    "$mdDialog",
    "$mdToast",
    "PosPaymentService",
    "AlertToastService"
  ];

  angular.module("tikonApp").component("pfPosPayment", {
    templateUrl: "app/components/partial-forms/pos-payment/pos-payment.html",
    controller: PosPaymentController,
    bindings: {
      totalAmount: "<",
      invoiceInfoId: "<?",
      terminalId: "<?",
      paymentUnit: "<?"
    }
  });
})();
